import { render, staticRenderFns } from "./CtcEmployee.vue?vue&type=template&id=21a50283&scoped=true"
import script from "./CtcEmployee.vue?vue&type=script&lang=js"
export * from "./CtcEmployee.vue?vue&type=script&lang=js"
import style0 from "./CtcEmployee.vue?vue&type=style&index=0&id=21a50283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a50283",
  null
  
)

export default component.exports